import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useStore } from "../../../../../../hooks";
import { InputText } from "../../../../../../elements";
import {
  UserWrapper,
  UserDetails,
  UserContent,
  UserLabel,
  UserColumnContainer,
  UserPhone,
  UserColumn,
  StyledSwitch,
  SwitchContainer,
} from "./UserGeneral.styled";
import CustomButton from "../../../../../../elements/v2/Buttons/CustomButton/CustomButton";
import { ReactComponent as PendingIcon } from "../../../../../../elements/icon/assets/pending.svg";
import { ReactComponent as ConfirmedIcon } from "../../../../../../elements/icon/assets/gg_check-o.svg";
import dayjs from "dayjs";
import Spinner from "../../../../../../components/common/Spinner";
import UserPermissionSelect from "../UserPermissionSelect/UserPermissionSelect";
const UserGeneral = observer(() => {
  const { listUserStore } = useStore();
  const { userData } = listUserStore;
  const [,setMultiOwners] = useState(false);
  const [specificView, setSpecificView] = useState(false);


  useEffect(() => {
    if (listUserStore.userData?.customer) {
      listUserStore
        .fetchAnnUsers(listUserStore.userData.customer)
        .catch((error) => {
          console.error("Error fetching ANN users:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listUserStore.userData?.customer]);

  const handleViewAllChange = (event) => {
    if (listUserStore.userData.view_all) {
      listUserStore.updateUserData("ann_user_id", "");
    }
    setMultiOwners(event.target.checked);
    if (event.target.checked) {
      setSpecificView(false);
    }
    listUserStore.updateUserData("view_all", event.target.checked);
  };

  const handleSpecificViewChange = (event) => {
    console.log("handleSpecificViewChange", event);
    setSpecificView(event.target.checked);
    setMultiOwners(event.target.checked);
    if (event.target.checked) {
      listUserStore.updateUserData("view_all", false);
    }
  };

  const handleContactOwnerChange = (e) => {
    const ownerId = e.target.value;
    const currentAnnUsersIds =
      listUserStore.userData.ann_user_id === "" ||
      listUserStore.userData.ann_user_id === undefined
        ? []
        : listUserStore.userData.ann_user_id?.split(",");

    console.log(currentAnnUsersIds);
    if (!currentAnnUsersIds.includes(ownerId)) {
      listUserStore.updateUserData(
        "ann_user_id",
        [...currentAnnUsersIds, ownerId].join(",")
      );
    }
  };

  const handleRemoveUser = (userId) => {
    const currentAnnUsersIds =
      listUserStore.userData.ann_user_id === "" ||
      listUserStore.userData.ann_user_id === undefined
        ? []
        : listUserStore.userData.ann_user_id?.split(",");

    listUserStore.updateUserData(
      "ann_user_id",
      currentAnnUsersIds.filter((id) => id !== String(userId)).join(",")
    );
  };
      
  return (
    <UserContent>
      {listUserStore.status !== "loading" &&
      Object.keys(listUserStore.userData).length ? (
        <UserWrapper>
          <UserDetails>
            <UserLabel>Name</UserLabel>
            <InputText
              placeholder="First Name"
              value={listUserStore.userData.first_name || ""}
              onChange={(e) =>
                listUserStore.updateUserData("first_name", e.target.value)
              }
              maxWidth="800px"
              displayError={!listUserStore.userData.first_name}
              validationError="First name is required."
            />
            <UserLabel>Last Name</UserLabel>
            <InputText
              placeholder="Last Name"
              value={listUserStore.userData.last_name || ""}
              onChange={(e) =>
                listUserStore.updateUserData("last_name", e.target.value)
              }
            maxWidth="800px"
            displayError={!listUserStore.userData.last_name}
            validationError="Last name is required."
          />
          <UserLabel>Email</UserLabel>
          <InputText
            placeholder="Email"
            value={listUserStore.userData.email || ''}
            maxWidth="800px"
            backgroundColor="#ECECEC"
          />
          <UserLabel>Phone Number</UserLabel>
          <UserColumnContainer>
              <InputText placeholder="+1" value="+1" readOnly width="60px" />
              <UserPhone>
                <InputText
                  placeholder="Phone number"
                  value={listUserStore.userData.phone || ""}
                  onChange={(e) =>
                    listUserStore.updateUserData("phone", e.target.value)
                  }
                  maxWidth="730px"
                />
              </UserPhone>
            </UserColumnContainer>
            <UserColumnContainer>
              <span>
                <UserLabel>Date Created</UserLabel>
                <InputText
                  value={dayjs(listUserStore.userData.insert_date || "").format(
                    "MM/DD/YYYY"
                  )}
                  backgroundColor="#ECECEC"
                />
              </span>
              <span>
                <UserLabel>Last Modified</UserLabel>
                <InputText
                  value={dayjs(
                    listUserStore.userData.last_modified || ""
                  ).format("MM/DD/YYYY")}
                  backgroundColor="#ECECEC"
                />
              </span>
            </UserColumnContainer>
            <div>
              <UserLabel>Assign Contact Owner </UserLabel>
              <SwitchContainer multiOwners={specificView}>
                <StyledSwitch
                  checked={userData.view_all || false}
                  onChange={handleViewAllChange}
                  aria-label="Toggle view all contact owners"
                />
                <Typography>
                  Select "View All" to grant access to all contact owners
                </Typography>
              </SwitchContainer>
              <UserPermissionSelect
                userId={listUserStore.userData?.id}
                viewAll={userData.view_all || false}
                annUsers={listUserStore.annUsers}
                status={listUserStore.userData.status}
                ann_user_id={userData.ann_user_id}
                specificView={specificView}
                handleStoreLoad={(users) =>
                  listUserStore.updateUserData("ann_user_id", users)
                }
                handleSpecificViewChange={handleSpecificViewChange}
                handleContactOwnerChange={handleContactOwnerChange}
                handleRemoveUser={(userId) => handleRemoveUser(userId)}
              />
            </div>
            <UserLabel>Status</UserLabel>
            {listUserStore.userData.status === "ENABLED" && (
              <CustomButton icon={ConfirmedIcon} text="Accepted" />
            )}
            {listUserStore.userData.status === "PENDING" && (
            <CustomButton icon={PendingIcon} text="Pending confirmation" />
            )}
            {listUserStore.userData.status === "DISABLED" && (
              <CustomButton icon={PendingIcon} text="Disabled" />
            )}
          </UserDetails>
        </UserWrapper>
      ) : (
        <UserColumn>
          <Spinner />
        </UserColumn>
      )}
    </UserContent>
  );
});

export default UserGeneral;
